import { render, staticRenderFns } from "./BrokersList.vue?vue&type=template&id=259cd4c1"
import script from "./BrokersList.vue?vue&type=script&lang=js"
export * from "./BrokersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./BrokersList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoaderAnimation: require('/vercel/path0/components/ui/LoaderAnimation.vue').default,MemberCard: require('/vercel/path0/components/MemberCard.vue').default,BrokerDetails: require('/vercel/path0/components/datablocks/BrokerDetails.vue').default,FloatingModal: require('/vercel/path0/components/FloatingModal.vue').default})
